import React from "react";

const LeaveLoader = () => {
    return (
        <table className="rty-table loading">
            <thead>
                <tr>
                    <th>Leave</th>
                    <th>Quantity</th>
                    <th>Notice Period (days)</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <>{
                    [...Array(10)].map((_, i) => (
                        <tr key={i}>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                        </tr>
                    ))
                }</>
            </tbody>
        </table>
    )
}

export default LeaveLoader;